module.exports = __webpack_public_path__ + "static/media/ebupot-picturemark-l.9ade918c.svg";